import * as R from 'ramda'

import toSchemaPath from 'coact/utils/schema/toSchemaPath'

import $arrivalProcessData from '../../../arrivalProcess/dataAccess/index.js'

import { dataAccess as purchaseOrderData } from '../../../purchaseOrder/index.js'

const schema = R.pipe(
  R.assocPath(
    toSchemaPath(['items', 0, 'reqRef']),
    $arrivalProcessData.schema.reqRef,
  ),
)(purchaseOrderData.schema)

export default schema
